import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { EventsService, GetActiveEventsRequestParams, IncidentEventSummary } from 'src/app/boxwood-api';

import { IncidentsApi, NamedIncident, GenericIncident, IncidentSettings, PriorityType } from '../../hickory-api';

@Injectable()
export class IncidentService {

  constructor(private incidentsV1Api: IncidentsApi, private incidentsV2Api: EventsService) { }

  getAllNamedIncidents(startPage: number, chunkSize: number, incidents: NamedIncident[] = [],
    observer?: Observer<NamedIncident[]>): Observable<NamedIncident[]> {

    let observable: Observable<NamedIncident[]> = null; // Null returned during recursion
    if (observer) {
      this.incidentsV1Api.getNamedIncidents(startPage, chunkSize).subscribe(r => {

        incidents = incidents.concat(r.items);

        // Look for more on the next page until we see them all
        if (r.totalItemCount > startPage * chunkSize) {
          this.getAllNamedIncidents(startPage + 1, chunkSize, incidents, observer);
        } else {
          observer.next(incidents);
        }
      }, err => {
        observer.error(err);
      });
    } else {
      // Create the initial observer
      observable = new Observable((observe: Observer<NamedIncident[]>) => {
        this.getAllNamedIncidents(startPage, chunkSize, incidents, observe);
      });
    }
    return observable;
  }

  getAllGenericIncidents(startPage: number, chunkSize: number, incidents: GenericIncident[] = [],
    observer?: Observer<GenericIncident[]>): Observable<GenericIncident[]> {

    let observable: Observable<GenericIncident[]> = null; // Null returned during recursion
    if (observer) {
      this.incidentsV1Api.getGenericIncidents(startPage, chunkSize).subscribe(r => {

        incidents = incidents.concat(r.items);

        // Look for more on the next page until we see them all
        if (r.totalItemCount > startPage * chunkSize) {
          this.getAllGenericIncidents(startPage + 1, chunkSize, incidents, observer);
        } else {
          observer.next(incidents);
        }
      }, err => {
        observer.error(err);
      });
    } else {
      // Create the initial observer
      observable = new Observable((observe: Observer<GenericIncident[]>) => {
        this.getAllGenericIncidents(startPage, chunkSize, incidents, observe);
      });
    }
    return observable;
  }

  getAllUserIncidents(startPage: number, chunkSize: number, type?: IncidentSettings.TypeEnum, priority?: PriorityType, incidents: IncidentSettings[] = [],
    observer?: Observer<IncidentSettings[]>): Observable<IncidentSettings[]> {

    let observable: Observable<GenericIncident[]> = null; // Null returned during recursion
    if (observer) {
      const typeString = type ? IncidentSettings.TypeEnum[type] : null;
      const priorityString: any = priority && priority !== PriorityType.NotSpecified ? PriorityType[priority] : null;
      this.incidentsV1Api.getIncidents(startPage, chunkSize, typeString, priorityString).subscribe(r => {

        incidents = incidents.concat(r.items);

        // Look for more on the next page until we see them all
        if (r.totalItemCount > startPage * chunkSize) {
          this.getAllUserIncidents(startPage + 1, chunkSize, type, priority, incidents, observer);
        } else {
          observer.next(incidents);
        }
      }, err => {
        observer.error(err);
      });
    } else {
      // Create the initial observer
      observable = new Observable((observe: Observer<GenericIncident[]>) => {
        this.getAllUserIncidents(startPage, chunkSize, type, priority, incidents, observe);
      });
    }
    return observable;
  }

  getIncidentV2Events(startPage: number, chunkSize: number, incidents: IncidentEventSummary[] = [],
    observer?: Observer<IncidentEventSummary[]>): Observable<IncidentEventSummary[]> {

    let observable: Observable<IncidentEventSummary[]> = null; // Null returned during recursion
    if (observer) {
      const request: GetActiveEventsRequestParams = {
        page: startPage,
        pageSize: chunkSize
      };
      this.incidentsV2Api.getActiveEvents(request).subscribe(r => {

        incidents = incidents.concat(r.incidentEvents);

        // Look for more on the next page until we see them all
        if (r.totalItemCount > startPage * chunkSize) {
          this.getIncidentV2Events(startPage + 1, chunkSize, incidents, observer);
        } else {
          observer.next(incidents);
        }
      }, err => {
        observer.error(err);
      });
    } else {
      // Create the initial observer
      observable = new Observable((observe: Observer<IncidentEventSummary[]>) => {
        this.getIncidentV2Events(startPage, chunkSize, incidents, observe);
      });
    }
    return observable;
  }

}
